import React from 'react';
import {
  Paper,
  Button,
  Typography,
  Box,
  IconButton,
  Slide,
  Stack,
} from '@mui/material';
import { CloseIcon, GetAppIcon } from "../../icons";
import { useInstallPWA } from '../hooks/useInstallPWA';

export const InstallBanner: React.FC = () => {
  const { canPrompt, installPrompt, dismissInstall } = useInstallPWA();

  if (!canPrompt) {
    return null;
  }

  const handleInstall = async () => {
    if (installPrompt) {
      await installPrompt();
    }
  };

  return (
    <Slide direction="up" in={canPrompt} mountOnEnter unmountOnExit>
      <Paper
        elevation={6}
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1300,
          p: 2,
          borderRadius: 0,
          borderTop: '2px solid',
          borderColor: 'primary.main',
        }}
      >
        <Box
          sx={{
            maxWidth: 1200,
            mx: 'auto',
            display: 'flex',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <GetAppIcon color="primary" sx={{ fontSize: 40, flexShrink: 0 }} />

          <Stack spacing={0.5} sx={{ flex: 1 }}>
            <Typography variant="subtitle1" fontWeight="bold">
              Instalar Aplicación
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Acceso rápido y sin conexión desde este dispositivo
            </Typography>
          </Stack>

          <Stack direction="row" spacing={1} sx={{ flexShrink: 0 }}>
            <Button
              variant="contained"
              onClick={handleInstall}
              startIcon={<GetAppIcon />}
              size="small"
            >
              Instalar
            </Button>
            <IconButton onClick={dismissInstall} size="small">
              <CloseIcon />
            </IconButton>
          </Stack>
        </Box>
      </Paper>
    </Slide>
  );
};
